import { render, staticRenderFns } from "./FileDeleteNotAllowedModal.vue?vue&type=template&id=018b137a&scoped=true&"
import script from "./FileDeleteNotAllowedModal.vue?vue&type=script&lang=ts&"
export * from "./FileDeleteNotAllowedModal.vue?vue&type=script&lang=ts&"
import style0 from "./FileDeleteNotAllowedModal.vue?vue&type=style&index=0&id=018b137a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b137a",
  null
  
)

export default component.exports